import { Download, ImageDown } from "lucide-react";

export const ExportBtn = ({ onCSV, onPNG }) => (
  <span className="flex items-center gap-1">
    {onCSV && (
      <button data-testid="export-csv-btn" onClick={onCSV} title="Export Excel/CSV"
        className="p-1.5 rounded-md text-slate-500 hover:text-white hover:bg-slate-700/60 transition-colors">
        <Download className="h-4 w-4" />
      </button>
    )}
    {onPNG && (
      <button data-testid="export-png-btn" onClick={onPNG} title="Download chart image"
        className="p-1.5 rounded-md text-slate-500 hover:text-white hover:bg-slate-700/60 transition-colors">
        <ImageDown className="h-4 w-4" />
      </button>
    )}
  </span>
);
